import {Injectable, Injector} from '@angular/core';
import {StateService} from '@uirouter/angular';
import {SettingsService} from 'app/original-services/settings.service';

declare let ga: any;
declare let gtag: any;

@Injectable({ providedIn: 'root' })
export class GAService {
    states: any[];
    isEnabled: boolean;
    isCreated: boolean;
    //ga is not defined now
    ga_id: string;

    constructor(private settings: SettingsService,
                private stateService: StateService) {
        this.states = stateService.get();
        this.isEnabled = settings.gaEnabled;
        if (this.ga_id) {
            this.initializeGa();
        }
    }

    trackPage(state: string) {
        if (!this.ga_id) {
            return;
        }
        try {
            if (ga && this.isEnabled && this.isCreated) {
                // ga('set', 'page', this.getStateName(state));
                // ga('set', 'page', state);
                let url = location.hash.slice(1);
                if (url[url.length - 1] === '/') {
                    url = url.slice(0, url.length - 1);
                }
                ga('set', 'page', url + '.html');
                ga('send', 'pageview');
            } else if (!ga) {
                this.gaNotInitialized(state);
            }
        } catch (err) {
            this.gaNotInitialized(state);
        }
    }

    trackEvent(data: any) {
        if (!this.ga_id) {
            return;
        }
        let event: any = {
            eventCategory: data.category,
            eventAction: data.action
        };
        if (data.label) event.eventLabel = data.label;
        if (data.value) event.eventValue = data.value;
        try {
            if (ga && this.isEnabled) {
                ga('send', 'event', event);
            } else if (!ga) {
                this.gaNotInitialized(data, true);
            }
        } catch (err) {
            this.gaNotInitialized(data, true);
        }
    }

    trackG4Event(eventName, repeat?) {
        try {
            if (gtag && this.isEnabled) {
                console.log(`'event', ${eventName}, {
                    'app_name': 'COMMITLY Web'  `);
                gtag('event', eventName, {
                    'app_name': 'COMMITLY Web'
                    });
            } else if (!gtag && !repeat) {
                setTimeout(() => {
                    this.trackG4Event(eventName, true);
                }, 1000);
            }
        } catch (err) {
            if (!repeat) {
                setTimeout(() => {
                    this.trackG4Event(eventName, true);
                }, 1000);
            }
        }
    }

    // private getStateName(state: string): string {
    //     return this.states.filter((item) => {
    //         return item.name === state;
    //     })[0].title;
    // }

    private gaNotInitialized(data: any, isEvent?: boolean) {
        setTimeout(() => {
            if (isEvent) {
                this.trackEvent(data);
            } else {
                this.trackPage(data);
            }
        }, 1000);
    }

    private initializeGa() {
        if (!this.ga_id) {
            return;
        }
        try {
            if (ga && this.isEnabled) {
                ga('create', this.ga_id, 'auto');
                this.isCreated = true;
            } else if (!ga) {
                setTimeout(() => {
                    this.initializeGa();
                }, 1000);
            }
        } catch (err) {
            setTimeout(() => {
                this.initializeGa();
            }, 1000);
        }
    }
}
